<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-06-06 09:59:09
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-06-10 15:04:07
 * @FilePath: /content-center/src/components/wiki/DiseaseName.vue
-->
<template>
  <div class="content-item flex align-items-center">
    <div class="content-item-label">
      <span class="red" v-if="JSON.parse(commonData[1].value)==='1'">*</span>{{ JSON.parse(commonData[2].value) || '百科名称'}}
    </div>
    <el-input
      id="selectRole"
      :maxlength="JSON.parse(commonData[0].value)"
      show-word-limit
      placeholder="请输入名称"
      v-model="input"
    ></el-input>
  </div>
</template>

<script>
import publicTool from '@/utils/public';
export default {
  name: "diseaseName",
  props:['contentName', 'actionType', 'names', 'commonData'],
  data() {
    return {
      name: publicTool.actionTypeCheck(this.actionType) + '名称'
    }
  },
  computed: {
    input: {
      get() {
        return this.contentName
      },
      set(val) {
        this.$emit('update:contentName',val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
